import { useRef, useState } from "react";

import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { Group, Image } from "@mantine/core";

import classes from "./index.module.css";

interface GalleryImage {
  src: string;
}

interface IGallery {
  images: GalleryImage[];
}

export default function Gallery({ images }: IGallery) {
  const [index, setIndex] = useState<number | null>(null);

  const zoomRef = useRef(null);

  return (
    <>
      <div className="thumbnails">
        <Group>
          {images.map((img, i) => (
            <Image
              src={img.src}
              key={i}
              onClick={() => setIndex(i)}
              className={classes.img}
            />
          ))}
        </Group>
      </div>

      <Lightbox
        open={index !== null}
        index={index ?? 0}
        close={() => setIndex(null)}
        slides={images}
        plugins={[Thumbnails, Zoom]}
        zoom={{ ref: zoomRef }}
        className={classes.backdrop}
        styles={{
          container: { backgroundColor: "rgba(0, 0, 0, 0.6)" },
        }}
      />
    </>
  );
}
